
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profil/uredi",
      function () {
        return require("private-next-pages/profil/uredi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profil/uredi"])
      });
    }
  